import type { ExploreFilterConfig } from './filter-config-types';

export const COMPANY_FILTER_CONFIGS: ExploreFilterConfig[] = [
  // Industry (Level-1 parent) → Sub-industry (Level-2 child), two dependent dropdowns
  // (NPJB-334). The controlled taxonomy replaces the old free-text industry, so neither
  // allows custom values. Sub-industry options/disable are driven by the filter panel.
  {
    key: 'industry',
    apiType: 'industry',
    label: 'Industry',
    allowCustom: false,
    selectAll: true,
    emptyText: 'All industries',
  },
  {
    key: 'subIndustry',
    apiType: 'sub-industry',
    label: 'Sub-Industry',
    allowCustom: false,
    selectAll: true,
    emptyText: 'All sub-industries',
  },
  {
    key: 'employeeRange',
    apiType: 'employee-range',
    label: 'Employee Range',
    allowCustom: false,
    selectAll: true,
    emptyText: 'Any size',
  },
  {
    key: 'revenueRange',
    apiType: 'revenue-range',
    label: 'Revenue Range',
    allowCustom: false,
    selectAll: true,
    emptyText: 'Any revenue',
  },
];

export const CONTACT_FILTER_CONFIGS: ExploreFilterConfig[] = [
  {
    key: 'seniority',
    apiType: 'seniority',
    label: 'Seniority',
    allowCustom: false,
    emptyText: 'All levels',
  },
  {
    key: 'jobFunction',
    apiType: 'job-function',
    label: 'Job Function',
    allowCustom: false,
    emptyText: 'All functions',
  },
  {
    key: 'geoRegion',
    apiType: 'region',
    label: 'Region',
    allowCustom: false,
    emptyText: 'All regions',
  },
  {
    key: 'country',
    apiType: 'country',
    label: 'Country',
    allowCustom: false,
    selectAll: true,
    emptyText: 'All countries',
  },
];
